import { inject,Injectable } from '@angular/core';
import { MatLegacyDialog } from '@angular/material/legacy-dialog';
import { firstValueFrom } from 'rxjs';
import { take } from 'rxjs/operators';
import { FileEntity } from '../dave-data-module/entities/file.entity';
import { FileDataService } from '../dave-data-module/services/file-data.service';
import {
FullscreenDialogComponent,
FullscreenDialogData
} from '../dave-fullscreen-dialog/components/fullscreen-dialog.component';

@Injectable({
    providedIn: 'root',
})
export class FilePopupServiceService {
    private fileDataService = inject(FileDataService);
    private dialog = inject(MatLegacyDialog);
    constructor() {}

    public async openFullscreen(fileId: number) {
        // Check if File is Image
        const file = await firstValueFrom(this.fileDataService.GetFileById$(fileId));
        if (!file && !file.MIMEType) return;
        if (file.MIMEType.indexOf('image/') > -1) {
            this.openImageSlider(fileId);
        } else if (file.MIMEType?.indexOf('application/pdf') > -1) {
            this.openEditor(file);
        } else {
            console.log('FilePopupServiceService.openFullscreen: Filetype not supported');
        }
    }

    public openEditor(file: FileEntity) {
        let showCheckedButton = false;
        if (!file.Checked) {
            showCheckedButton = true;
        }
        const dialogRef = this.dialog
            .open<FullscreenDialogComponent, FullscreenDialogData>(FullscreenDialogComponent, {
                ...FullscreenDialogComponent.DefaultConfig,
                data: { file, version: file.GetLastVersion(), setCheckedButton: showCheckedButton },
                id: 'fullScreenDialogId',
            });
        dialogRef
            .backdropClick()
            .pipe(take(1))
            .subscribe(async () => {
                // dies ist nötig da zuerst der pdf viewer aufgeräumt werden muss, die funktionirt onDestroy nicht mehr
                await this.dialog.getDialogById('fullScreenDialogId').componentInstance.Close();
                this.dialog.getDialogById('fullScreenDialogId').close();
            });
        return dialogRef;
    }
    public async openImageSlider(fileId: number) {
        const files = [fileId];
        // Wenn vorher importiert, kommt der Fehler "Uncaught ReferenceError: Cannot access 'FileExplorerComponent' before initialization"
        const { DaveImageSliderComponent } = await import('src/app/dave-image-slider/dave-image-slider.component');

        return this.dialog.open(DaveImageSliderComponent, {
            data: { fileIds: files, fileId },
            width: '100%',
            height: '100%',
            maxWidth: '100%',
            panelClass: 'custom-dialog-class-without-padding',
            autoFocus: false,
        });

    }
}
